export default __webpack_public_path__ + "static/media/senderId.aab4c01f.svg";